import { dbToGain } from "@opendaw/lib-dsp";
export var AudioUtils;
(function (AudioUtils) {
    // -90dB safely catches true digital zeros (pipeline startup silence) without touching real mic noise floor (~-60 to -80dB)
    AudioUtils.findFirstNonSilentSample = (frames, startFrame, thresholdDb = -90.0) => {
        const threshold = dbToGain(thresholdDb);
        const length = frames[0]?.length ?? 0;
        for (let i = startFrame; i < length; i++) {
            for (const channel of frames) {
                if (Math.abs(channel[i]) > threshold) {
                    return i;
                }
            }
        }
        return length;
    };
    AudioUtils.findLastNonSilentSample = (buffer, thresholdDb = -72.0) => {
        const threshold = dbToGain(thresholdDb);
        const numChannels = buffer.numberOfChannels;
        const length = buffer.length;
        let lastNonSilentSample = 0;
        for (let channel = 0; channel < numChannels; channel++) {
            const channelData = buffer.getChannelData(channel);
            for (let i = length - 1; i >= 0; i--) {
                if (Math.abs(channelData[i]) > threshold) {
                    lastNonSilentSample = Math.max(lastNonSilentSample, i);
                    break;
                }
            }
        }
        return lastNonSilentSample + 1;
    };
})(AudioUtils || (AudioUtils = {}));
